import TfwHomeWidget from './TfwHomeWidget';

export default TfwHomeWidget;